import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cn } from "../../lib/utils";

const buttonVariants = {
    default: "bg-[#082359] text-white hover:bg-[#061a42] focus-visible:ring-[#082359]",
    destructive: "bg-red-600 text-white hover:bg-red-700 focus-visible:ring-red-600",
    outline: "border border-[#082359] text-[#082359] bg-transparent hover:bg-[#082359]/10",
    "outline-secondary": "border border-gray-400 text-gray-700 bg-transparent hover:bg-gray-100",
    "outline-success": "border border-green-600 text-green-700 bg-transparent hover:bg-green-50",
    secondary: "bg-gray-100 text-gray-900 hover:bg-gray-200",
    ghost: "hover:bg-gray-100 text-gray-700",
    link: "text-[#082359] underline-offset-4 hover:underline",
    success: "bg-green-600 text-white hover:bg-green-700",
};

const buttonSizes = {
    default: "h-9 px-4 py-2 text-sm",
    sm: "h-8 px-3 text-xs",
    lg: "h-11 px-6 text-base",
    icon: "h-9 w-9",
};

const Button = React.forwardRef(
    (
        {
            className,
            variant = "default",
            size = "default",
            disabled,
            children,
            type = "button",
            asChild = false,
            ...props
        },
        ref
    ) => {
        const Comp = asChild ? Slot : "button";
        return (
            <Comp
                ref={ref}
                type={asChild ? undefined : type}
                disabled={disabled}
                className={cn(
                    "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
                    buttonVariants[variant] || buttonVariants.default,
                    buttonSizes[size] || buttonSizes.default,
                    className
                )}
                {...props}
            >
                {children}
            </Comp>
        );
    }
);
Button.displayName = "Button";

export { Button };
